﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import { headerComponents } from './header';
import TKManager from '@tk/basics/tk.manager';
import TKCarousel from '@tk/components/tk.carousel';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKDialog from '@tk/components/tk.dialog';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKArticleList from '@tk/components/tk.article.list';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKAssetGallery from '@tk/components/tk.asset.gallery';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKSelection from '@tk/controls/tk.selection';
import TKArtSpecTable from '@tk/components/tk.art.spec.table';
import TKShowMore from '@tk/components/tk.show.more';
import TKSelectRedirect from '@tk/controls/tk.select.redirect';
import TKPopup from '@tk/components/tk.popup';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKCompareButton from '@tk/components/compare/tk.compare.button';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import { configureStore } from '@tk/utilities/tk.use.store';

import 'tippy.js/dist/tippy.css';
import '@scss/modules/article.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});

export default class Article extends TKModuleFactory {
    constructor() {
        super([
            ...headerComponents,
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-asset-gallery', constructor: TKAssetGallery },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-art-spec-table', constructor: TKArtSpecTable },
            { name: 'tk-show-more', constructor: TKShowMore },
            { name: 'tk-select-redirect', constructor: TKSelectRedirect },
            { name: 'tk-popup', constructor: TKPopup },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-tracking', constructor: TKTracking },
        ]);
    }
}

new Article();
